(function($){
    var $search = {

        $param : {
            'keyword'  : '',
            'term'     : 'all',
            'paginate' : 1,
        },
        $uri           : '/experts/project-search/',
        $json          : '',
        $html          : '',
        $post_total    : 0, // 検索結果の合計数
        $post_number   : 0, // 取得した数
        $post_type     : 0, // 0;更新, 1:継続
        $scroll        : 0,
        $postContainer    : $('.catWholeRow'),
        $catListContainer : $('.catListContainer'),
        $footerContainer  : $('.footer, .RegistBtnContainer'),
        $postSearchForm   : $('.postSearch'),
        $searchKeyword    : $('.searchKeyword'),
        $searchPostCount  : $('.searchPostCount'),

        setCheckbox: function () {
            var self = this;
            var term  = this.$param['term'].split(',');
            var value = '';
            for (var i = 0; i < term.length; i++) {
                if (term[i] != '') {
                    var data = $('li[data-filter="' + term[i] + '"]');
                    data.addClass('active');
                    data.children('input').prop("checked", true);
                    var divide = (i > 0)? ',': '';
                    value += divide + term[i];
                }
            }
            if (term.length == 1 && term[0] == '') {
                var data = $('li[data-filter="all"]');
                data.addClass('active');
                data.children('input').prop("checked", true);
            }
            $('input[name="term"]').val(value);
            self.onChangeCheckbox();
            self.onChangeInputTerm();
        },

        setSearchPost: function () {
            var self = this;
            self.$catListContainer.addClass('loading');
            $.ajax(
                self.$uri,
                {
                    type: 'get',
                    data: {
                        'keyword'  : self.$param['keyword'],
                        'term'     : self.$param['term'],
                        'paginate' : self.$param['paginate']
                    },
                    dataType: 'json'
                }
            )
            // 検索失敗時には、その旨をダイアログ表示
            .fail(function() {
                self.renderErrorResults();
            })
            // 検索成功時にはページに結果を反映
            .done(function(json) {
                //console.log(json);
                self.$json = json;
                self.$post_total  = json.post_total;
                self.$post_number = json.post_number;
                if (json.post_total > 0) {
                    self.renderSearchResults(0);
                } else {
                    self.renderNoResults();
                }
            });
        },

        renderErrorResults: function () {
            self.$postContainer.html('<div class="message">エラーが発生しました。</div>');
            self.$catListContainer.removeClass('loading');
            self.$postSearchForm.find('button').prop('disabled', false);
            self.$footerContainer.removeClass('searching');
        },

        renderNoResults: function () {
            var self = this;
            self.$postContainer.html('<div class="message">該当する求人情報が<br class="hide-on-pc">見つかりませんでした。</div>');
            var keywords = self.$json.keywords.join(',');
            keywords = (keywords)? keywords + 'の': '';
            self.$searchKeyword.text(keywords);
            self.$catListContainer.removeClass('loading');
            self.$postSearchForm.find('button').prop('disabled', false);
            self.$footerContainer.removeClass('searching');
        },

        renderSearchResults: function ($i) {
            var self = this;
            if ($i < self.$post_number) {
                self.addPostMarkUp($i);
            } else {
                if (self.$post_type) {
                    self.$postContainer.append(self.$html);
                } else {
                    self.$postContainer.html(self.$html);
                }
                self.$html = '';
                var keywords = self.$json.keywords.join(',');
                keywords = (keywords)? keywords + 'の': '';
                self.$searchKeyword.text(keywords);
                self.$searchPostCount.text(self.$json.post_total);
                self.$catListContainer.removeClass('loading');
                self.$postSearchForm.find('button').prop('disabled', false);
                self.$scroll = 1;
            }
        },

        addPostMarkUp: function ($i) {
            var self     = this;
            var post     = self.$json.posts[$i];
            var status   = (post.project_status == '募集終了')? '<div class="catImgTitle">募集終了</div>': '';
            var language = (post.language)? '<p class="catInfoLanguage mb15px"><span class="clgreen">&nbsp;言語</span>' + post.language + '</p>': '<p class="mb15px">&nbsp;</p>';
            var markUp   = ' <br class="hide-on-sp">' +
                '   <div class="col-md-4 col-sm-12 catWholeContainer" >' +
                '       <a href="' + post.permalink + '" class="catImgContainer">' +
                '           <div class="catImgWrapper">' +
                '               <img src="' + post.thumbNailImage + '" alt="">' +
                '               ' + status +
                '           </div>' +
                '           <div class="catImgContent">' + post.project_title + '</div>' +
                '           <div class="catImgContentInfo">' +
                '               <p class="catInfoPerson"><span class="clgreen">&nbsp;役職</span>' + post.position + '</p>' +
                '               <p class="catInfoCoin"><span class="clgreen">&nbsp;単価</span>' + post.project_price + '</p>' +
                '               <p class="catInfoMobile mb5px"><span class="clgreen">&nbsp;最寄駅</span>' + post.closest_station + '</p>' +
                '               ' + language +
                '           </div>' +
                '       </a>' +
                '       <a class="catRegistrationButton mb115px" href="/experts/registration/">お問い合わせ</a>' +
                '   </div>';
            $i++;
            self.$html += markUp;
            self.renderSearchResults($i);
        },

        onChangeCheckbox: function () {
            var self = this;
            $('li.term input').click(function(){
                if ($(this).parent('li').hasClass('active')) {
                    $(this).parent('li').removeClass('active');
                } else {
                    $(this).parent('li').addClass('active');
                    $('li.all').removeClass('active');
                    $('li.all input').prop("checked", false);
                }
                self.onChangeInputTerm();
            });
            $('li.all input').click(function(){
                if ($(this).parent('li').hasClass('active')) {
                    $(this).parent('li').removeClass('active');
                } else {
                    $(this).parent('li').addClass('active');
                    $('li.term').removeClass('active');
                    $('li.term input').prop("checked", false);
                }
                self.onChangeInputTerm();
            });

        },

        onChangeInputTerm: function () {
            var self = this;
            var value = '';
            $('li.active').each(function(i){
                var divide = (i > 0)? ',': '';
                var filter = $(this).data('filter');
                value += divide + filter;
            });
            $('input[name="term"]').val(value);
            self.$param['keyword']  = $('input[name="keyword"]').val();
            self.$param['term']     = $('input[name="term"]').val();
            self.$param['paginate'] = 1;
            self.$post_type = 0;
            self.$footerContainer.addClass('searching');
            self.setSearchPost();
            self.trackPageview();
            self.replaceSearchUri();
        },

        submitSearch: function () {
            var self = this;
            self.$postSearchForm.submit(function(e){
                e.preventDefault(); // 二重送信を防止
                self.$postSearchForm.find('button').prop('disabled', true);
                self.$param['keyword']  = $('input[name="keyword"]').val();
                self.$param['term']     = $('input[name="term"]').val();
                self.$param['paginate'] = 1;
                self.$post_type = 0;
                self.$footerContainer.addClass('searching');
                self.setSearchPost();
                self.trackPageview();
                self.replaceSearchUri();
            });
        },

        onScrollBottom: function () {
            var self = this;
            $(window).on('scroll', function(){
                if (self.$scroll) {
                    var docHeight = $(document).height();
                    var winHeight = $(window).height() + $(window).scrollTop();
                    var position  = (docHeight - winHeight) / docHeight;
                    if (position < 0.008) {
                        self.$scroll = 0;
                        self.$param['paginate']++;
                        if (self.$param['paginate'] <= self.$json.page_totale) {
                            self.$post_type = 1;
                            self.setSearchPost();
                            self.trackPageview();
                            self.replaceSearchUri();
                        } else {
                            self.$scroll = 1;
                            self.$footerContainer.removeClass('searching');
                        }
                    }
                }
            });
        },

        replaceSearchUri: function () {
            var self = this;
            var uri  = '?keyword='+self.$param['keyword']+'&term='+self.$param['term']+'&paginate='+self.$param['paginate'];
            window.history.replaceState(null, null, uri); // URL書き換え
        },

        trackPageview: function () {
            var self    = this;
            var keyword = self.$param['keyword'];
            var term    = self.$param['term'];
            var page    = self.$param['paginate'];
            // GAにトラッキング
            dataLayer.push({
                'event':   'projectsSearch',
                'keyword': keyword,
                'term':    term,
                'page':    page,
            });
        },

        int: function ($) {
            var self = this;
            if(app_start_local_data.projects_archive > 0) {
                self.$footerContainer.addClass('searching');
                var param = location.search.substring(1).split('&');
                for(var i = 0; i < param.length; i++) {
                    var value = param[i].split('=');
                    self.$param[value[0]] = value[1];
                }
                $('input[name="keyword"]').val(decodeURI(self.$param['keyword']));
                $('input[name="term"]').val(decodeURI(self.$param['term']));
                self.setCheckbox();
                self.submitSearch();
                self.onScrollBottom();
            }
        }
    };

    $(function(){
        $search.int($);
    });

}(jQuery));